import React from 'react';
import { Heading1, Paragraph, Button } from '../style';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const Home = () => {
    const history = useHistory();

    return (
        <>
            <Heading1 marginBottom='1rem'>
                Wait, looks like there's nothing here? 👀
            </Heading1>
            <Paragraph marginBottom='2rem'>
                Yes you are right! Alfan is still building the web currently,
                feel free to come back later. The button below will bring you
                back to /links page. ⤵️
            </Paragraph>
            <Button onClick={() => history.push('/links')}>
                <FiArrowLeft style={{ marginRight: '1rem' }} />
                Bring me back
            </Button>
        </>
    );
};

export default Home;
